/**
 * Base theme color for the application.
 * Change this single value to re-skin the entire UI.
 * The shade 600 in the generated palette will match this hex exactly.
 *
 * See THEME.md in the project root for details.
 */
export const THEME_COLOR = '#0891B2';
